import { render, staticRenderFns } from "./GroupBlackAI.vue?vue&type=template&id=20316e1c&"
import script from "./GroupBlackAI.vue?vue&type=script&lang=js&"
export * from "./GroupBlackAI.vue?vue&type=script&lang=js&"
import style0 from "./GroupBlackAI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports